import { ModalOptions, modalController } from '@ionic/core';
import { translate } from './translate';
import { trackIntercomEvent } from './intercom';
import { AmplitudeEvents, amplitudeLogEvent } from './amplitude';
import { Capacitor } from '@capacitor/core';

export async function showPreloadErrorModal() {
  trackIntercomEvent('preloading_error');
  amplitudeLogEvent(AmplitudeEvents.preloading_error);
  if (!Capacitor.isNativePlatform()) return showPreloadErrorDesktopModal();
  const options: ModalOptions = {
    component: 'sw-small-modal',
    cssClass: 'sw-small-modal',
    componentProps: {
      backgroundImage: '/assets/img/error.jpg',
      messageTitle: translate('PRELOADING_ERROR'),
      message: translate('PRELOADING_ERROR_DESC'),
      primaryCTAText: translate('RETURN_TO_SETTINGS'),
      primaryCTAFunction: () => {
        document.querySelector('ion-router').push('/settings');
      },
      secondaryCTAText: translate('DISMISS'),
    },
  };
  const modal = await modalController.create(options);
  return modal.present();
}

async function showPreloadErrorDesktopModal() {
  const options: ModalOptions = {
    component: 'sw-small-modal',
    cssClass: 'sw-small-modal',
    componentProps: {
      backgroundImage: '/assets/img/error.jpg',
      messageTitle: translate('THERE_WAS_AN_ERROR'),
      message: translate('PRELOADING_ERROR'),
      primaryCTAText: translate('RELOAD'),
      primaryCTAFunction: () => {
        location.reload();
      },
      secondaryCTAText: translate('DISMISS'),
    },
  };
  const modal = await modalController.create(options);
  return modal.present();
}
